var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import $request from '../../utils/request';
var state = {
    driverDetail: {},
    driverList: [],
    showDriverCheckDialog: false,
    showDriverEditDialog: false,
};
var mutations = {
    update: function (state, props) {
        for (var key in props) {
            if (state.hasOwnProperty(key)) {
                state[key] = props[key];
            }
        }
    },
};
var actions = {
    GET_DRIVER_DETAIL_INFO: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 获取司机详情
        var type = params.type;
        delete params.type;
        $request({
            method: 'post',
            url: '/proxy/vehicle/driver/driver/detail',
            data: __assign({}, params),
        }).then(function (res) {
            if (!res)
                return;
            if (res && !res.errorCode) {
                commit('update', {
                    driverDetail: res.data,
                    showDriverCheckDialog: type === 'check' ? true : false,
                    showDriverEditDialog: type === 'edit' ? true : false,
                });
            }
        });
    },
    GET_DRIVER_LIST: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 获取司机查询列表
        $request({
            method: 'post',
            url: '/proxy/vehicle/driver/driver/search',
            data: __assign({}, params),
        }).then(function (res) {
            if (!res)
                return;
            if (res && !res.errorCode) {
                commit('update', {
                    driverList: res,
                });
            }
        });
    },
};
export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
